<template>
  <div class="itemRow">
      <IconConverter :style="doRightStyles" :txt="signTxt" :fontSize="fontSize" />
      <IconConverter :style="doBothStyles" :txt="elementTxt" :fontSize="fontSize" />
      <IconConverter :style="doBothStyles" :txt="qualityTxt" :fontSize="fontSize" />
      <IconConverter :style="doBothStyles" :txt="houseTxt" :fontSize="fontSize" />
      <IconConverter :style="doLeftStyles" :txt="planetTxt" :fontSize="fontSize" />
  </div>
</template>


<script>
import IconConverter from '@/components/converters/IconConverter.vue';

export default {
        name: "SignsAllIconsDisplayer",
        props: {
            fontSize: {
            type: String,
            default: "."
            },
            signTxt: {
            type: String,
            default: "."        
            },
            elementTxt: {
            type: String,
            default: "."        
            },
            qualityTxt: {
            type: String,
            default: "."        
            },
            houseTxt: {
            type: String,
            default: ".wwwew"        
            },   
            marginBetween: {
            type: String,
            default: "20px" 
            },
            planetTxt: {
            type: String,
            default: "20px"        
            }
        },
  computed: {
    doBothStyles() {
      return {
        "margin-right": this.marginBetween,
        "margin-left": this.marginBetween,
      };
    },
    doLeftStyles() {
      return {
        "margin-left": this.marginBetween
      };
    },
    doRightStyles() {
      return {
        "margin-right": this.marginBetween
      };
    }


  },
  components: {IconConverter}
}
</script>
<style>
.itemRow {
  display: inline-flex;
  position: relative;
  align-items: center;
  text-align: center;
}
</style> 